<em class="bi bi-{{icon}}"></em>&nbsp;